/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'help': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<circle pid="0" cx="12" cy="15.824" r=".753"/><path pid="1" d="M12 14.256a.75.75 0 01-.75-.75v-1c0-.529.419-.818.862-1.124.623-.43 1.138-.83 1.138-1.376A1.209 1.209 0 0012 8.756a1.252 1.252 0 00-1.25 1.25.75.75 0 01-1.5 0A2.753 2.753 0 0112 7.256a2.721 2.721 0 012.75 2.75 3.3 3.3 0 01-1.786 2.61c-.079.055-.152.1-.214.147v.743a.75.75 0 01-.75.75z"/><path pid="2" d="M12 5a7 7 0 11-7 7 7.008 7.008 0 017-7m0-2a9 9 0 109 9 9 9 0 00-9-9z"/>'
  }
})
